import React, { useState, useEffect } from 'react';
import './InstallPrompt.css';

const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    // Check if already installed (standalone mode)
    const standalone = window.matchMedia('(display-mode: standalone)').matches 
      || window.navigator.standalone === true;
    setIsStandalone(standalone);

    // Check if iOS
    const ios = /iPad|iPhone|iPod/.test(navigator.userAgent);
    setIsIOS(ios);

    // Listen for the beforeinstallprompt event (Android/Chrome)
    const handleBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallButton(true);
      console.log('PWA install prompt ready');
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstall);

    // Listen for successful install
    window.addEventListener('appinstalled', () => {
      console.log('PWA installed successfully');
      setShowInstallButton(false);
      setDeferredPrompt(null);
    });

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    // Show the install prompt
    deferredPrompt.prompt();

    // Wait for user response
    const { outcome } = await deferredPrompt.userChoice;
    console.log('Install prompt outcome:', outcome);

    // Clear the prompt
    setDeferredPrompt(null);
    setShowInstallButton(false);
  };

  const handleDismiss = () => {
    setShowInstallButton(false);
    // Store dismissal in localStorage to not show again for a while
    localStorage.setItem('pwaPromptDismissed', Date.now().toString());
  };

  // Don't show if already installed
  if (isStandalone) return null;

  // Check if user dismissed recently (within 7 days)
  const dismissed = localStorage.getItem('pwaPromptDismissed');
  if (dismissed && Date.now() - parseInt(dismissed) < 7 * 24 * 60 * 60 * 1000) {
    return null;
  }

  // Show iOS instructions
  if (isIOS && !isStandalone) {
    return (
      <div className="install-prompt ios-prompt">
        <div className="install-content">
          <span className="install-icon">📲</span>
          <div className="install-text">
            <strong>Install VoiceMeet</strong>
            <p>Tap <span className="share-icon">⬆️</span> then "Add to Home Screen"</p>
          </div>
          <button className="dismiss-btn" onClick={handleDismiss}>✕</button>
        </div>
      </div>
    );
  }

  // Show Android/Chrome install button
  if (showInstallButton) {
    return (
      <div className="install-prompt android-prompt">
        <div className="install-content">
          <span className="install-icon">📲</span>
          <div className="install-text">
            <strong>Install VoiceMeet App</strong>
            <p>Add to your home screen for quick access</p>
          </div>
          <button className="install-btn" onClick={handleInstallClick}>Install</button>
          <button className="dismiss-btn" onClick={handleDismiss}>✕</button>
        </div>
      </div>
    );
  }

  return null;
};

export default InstallPrompt;